"use strict";
/* globals module */
/**
 * @module articleACLClient
 * @description  Article ACL Client provides an easy way to consume  Articles REST API end-points. In order to obtain needed routes `articleACLClient` uses `articleACLRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var ArticleACLClient = /** @class */ (function () {
    function ArticleACLClient(articleACLRoute, apiClient) {
        this.articleACLRoute = articleACLRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleACLClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list of ACL policies established for the specified article resource.
     * @method
     * @example articleACLClient.get({id: '<article-id>'})
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleACLClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update acl action has been performed, this action creates new ACL policy for the specified article resource.
     * @method
     * @param options An ACL policy object that needs to be updated in the system. This object specifies parameters necessary for establishing user and/or role set of rights.
     * @returns A promise that is resolved once the update acl action has been performed.
     * @example let options = {id : '<article-id>'};
                let aclObj =  {
                    actionId: '<action-id'>,
                    roleId: '<roleId>',
                    userId: '<userId>'
                };
                options[baasicConstants.modelPropertyName] = aclObj;
                articleACLClient.update(options)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleACLClient.prototype.update = function (options) {
        return this.apiClient.put(this.routeDefinition.update(options), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the removeByUser action has been performed. This action deletes ACL policy assigned to the specified user and article resource.
     * @method
     * @param articleId Article id which uniquely identifies article resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and article resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data An ACL policy object that needs to be updated in the system.
     * @returns A promise that is resolved once the removeByUser action has been performed.
     * @example articleACLClient.removeByUser('<article-id>', '<access-action>', '<username>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleACLClient.prototype.removeByUser = function (articleId, action, user, data) {
        return this.apiClient.delete(this.articleACLRoute.deleteByUser(articleId, action, user, data));
    };
    /**
     * Returns a promise that is resolved once the removeByRole action has been performed. This action deletes ACL policy assigned to the specified role and article resource.
     * @method
     * @param articleId Article id which uniquely identifies article resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and article resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data An ACL policy object that needs to be updated in the system.
     * @returns A promise that is resolved once the removeByRole action has been performed.
     * @example articleACLClient.removeByRole('<article-id>', '<access-action>', '<role-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleACLClient.prototype.removeByRole = function (articleId, action, role, data) {
        return this.apiClient.delete(this.articleACLRoute.deleteByRole(articleId, action, role, data));
    };
    var _a, _b;
    ArticleACLClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleACLRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleACLRoute !== "undefined" && _1.ArticleACLRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleACLClient);
    return ArticleACLClient;
}());
exports.ArticleACLClient = ArticleACLClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
